import { Model, belongsTo } from 'miragejs'

export default Model.extend({
  bookMetadata: belongsTo('book-library/book-metadata'),
})
